module.exports = __webpack_public_path__ + "cancellara-live-dist/img/come-funziona.c8c9626e.jpg";